export function t(key, forceLocale) {
  const defaultLocale = 'de';
  const locale = forceLocale || (window && window.Shopify && window.Shopify.locale);

  const translations = {
    de: {
      readMore: 'Mehr lesen'
    },
    fr: {
      readMore: 'En savoir plus'
    },
    en: {
      readMore: 'Read more'
    }
  }

  return translations[locale][key] || translations[defaultLocale][key] || '';
}